module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('form', {
    staticClass: "m-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "general_damages_psla",
      "label": "General Damages (PSLA)",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.generalDamages),
      expression: "generalDamages",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control:general_damages_psla.valid",
      value: ({
        type: 'number',
        rules: 'valid'
      }),
      expression: "{type:'number', rules:'valid'}",
      arg: "general_damages_psla",
      modifiers: {
        "valid": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "general_damages_psla",
      "id": "general_damages_psla",
      "step": "0.01",
      "type": "number"
    },
    domProps: {
      "value": (_vm.generalDamages)
    },
    on: {
      "focus": function($event) {
        _vm.generalDamages = _vm.generalDamages || ''
      },
      "blur": [function($event) {
        _vm.generalDamages = _vm.generalDamages || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.generalDamages = _vm._n($event.target.value)
      }, _vm.calcInterestValue]
    }
  }), _vm._v(" "), (_vm.diseaseType === 'Mesothelioma') ? _c('span', {
    staticClass: "a-form-inputs--help"
  }, [_vm._v("\n                        Damages can be calculated using the calculator available\n                        "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleGeneralDamagesPslaModal()
      }
    }
  }, [_vm._v("\n                            here\n                        ")])]) : _vm._e()]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "funeral_expenses",
      "label": "Funeral Expenses",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.funeralExpenses),
      expression: "funeralExpenses",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control:funeral_expenses.valid",
      value: ({
        type: 'number',
        rules: 'valid'
      }),
      expression: "{type:'number', rules:'valid'}",
      arg: "funeral_expenses",
      modifiers: {
        "valid": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    staticClass: "number",
    attrs: {
      "autocomplete": "off",
      "min": "0",
      "name": "funeral_expenses",
      "type": "number"
    },
    domProps: {
      "value": (_vm.funeralExpenses)
    },
    on: {
      "focus": function($event) {
        _vm.funeralExpenses = _vm.funeralExpenses || ''
      },
      "blur": [function($event) {
        _vm.funeralExpenses = _vm.funeralExpenses || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.funeralExpenses = _vm._n($event.target.value)
      }, _vm.calcInterestValue]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('funeral_expenses')
    }
  }, [_vm._v("\n                        Funeral expenses should be greater than £0.00\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "loss_of_spouse",
      "label": "Loss of Spouse",
      "before-after": "pound",
      "tip-icon": "info",
      "tip-text": "Click to view information",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "loss_of_spouse_award",
      "modal-name": 'lossOfSpouse'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.lossOfSpouse),
      expression: "lossOfSpouse",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:loss_of_spouse.valid",
      value: ({
        type: 'number',
        rules: 'valid'
      }),
      expression: "{type:'number', rules:'valid'}",
      arg: "loss_of_spouse",
      modifiers: {
        "valid": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "name": "loss_of_spouse",
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.lossOfSpouse)
    },
    on: {
      "focus": function($event) {
        _vm.lossOfSpouse = _vm.lossOfSpouse || ''
      },
      "blur": [function($event) {
        _vm.lossOfSpouse = _vm.lossOfSpouse || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.lossOfSpouse = _vm._n($event.target.value)
      }, _vm.calcInterestValue]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('loss_of_spouse')
    }
  }, [_vm._v("\n                        Loss of spouse should be greater than £0.00\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "past_cost_of_travel",
      "label": "Past Cost of Travel",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfTravel),
      expression: "pastCostOfTravel",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:past_cost_of_travel.valid",
      value: ({
        type: 'number',
        rules: 'valid'
      }),
      expression: "{type:'number', rules:'valid'}",
      arg: "past_cost_of_travel",
      modifiers: {
        "valid": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "name": "past_cost_of_travel",
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfTravel)
    },
    on: {
      "focus": function($event) {
        _vm.pastCostOfTravel = _vm.pastCostOfTravel || ''
      },
      "blur": [function($event) {
        _vm.pastCostOfTravel = _vm.pastCostOfTravel || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfTravel = _vm._n($event.target.value)
      }, _vm.calcInterestValue]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('past_cost_of_travel')
    }
  }, [_vm._v("\n                        Past cost of travel should be greater than £0.00\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "miscellaneous_costs",
      "label": "Miscellaneous - Medication, Appliances, Additional Food & Energy Costs",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.misc),
      expression: "misc",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:miscellaneous_costs.valid",
      value: ({
        type: 'number',
        rules: 'valid'
      }),
      expression: "{type:'number', rules:'valid'}",
      arg: "miscellaneous_costs",
      modifiers: {
        "valid": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "name": "miscellaneous_costs",
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.misc)
    },
    on: {
      "focus": function($event) {
        _vm.misc = _vm.misc || ''
      },
      "blur": [function($event) {
        _vm.misc = _vm.misc || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.misc = _vm._n($event.target.value)
      }, _vm.calcInterestValue]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('miscellaneous_costs')
    }
  }, [_vm._v("\n                        Miscellaneous should be greater than £0.00\n                    ")])], 1), _vm._v(" "), _vm._l((_vm.headsOfLoss.length), function(index) {
    return _c('div', [_c('head-of-loss', {
      attrs: {
        "index": index - 1
      },
      on: {
        "update": function($event) {
          return _vm.updateValid()
        }
      }
    })], 1)
  }), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--no-margin u-r-margin-top-20 u-r-margin-bottom-20",
    on: {
      "click": _vm.addNewHeadOfLoss
    }
  }, [_vm._v("\n                    Add Another Head of Loss\n                ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "label": "Past Loss of Earnings",
      "tip-text": "You have two options to assess the past loss of earnings claim — click the help icon to find out more.",
      "tip-icon": "info",
      "tip-side": "left",
      "tip-width": "200",
      "tip-name": "pastLossOfEarnings",
      "modalName": "pastLossOfEarningsModal"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pastLossOfEarningsType),
      expression: "pastLossOfEarningsType"
    }],
    attrs: {
      "id": "pastLossOfEarningsType",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pastLossOfEarningsType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "own"
    }
  }, [_vm._v("Enter your own figure")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "manual"
    }
  }, [_vm._v("Detailed calculation")])])]), _vm._v(" "), (_vm.pastLossOfEarningsType === 'own') ? _c('control', {
    attrs: {
      "for": "ownPastLossOfEarningsFigure",
      "label": "Enter Your Own Figure",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ownPastLossOfEarningsFigure),
      expression: "ownPastLossOfEarningsFigure",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:ownPastLossOfEarningsFigure.valid",
      value: ({
        type: 'number',
        rules: 'valid'
      }),
      expression: "{type:'number', rules:'valid'}",
      arg: "ownPastLossOfEarningsFigure",
      modifiers: {
        "valid": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "ownPastLossOfEarningsFigure",
      "min": "0.00"
    },
    domProps: {
      "value": (_vm.ownPastLossOfEarningsFigure)
    },
    on: {
      "focus": function($event) {
        _vm.ownPastLossOfEarningsFigure = _vm.ownPastLossOfEarningsFigure || ''
      },
      "blur": [function($event) {
        _vm.ownPastLossOfEarningsFigure = _vm.ownPastLossOfEarningsFigure || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ownPastLossOfEarningsFigure = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('ownPastLossOfEarningsFigure')
    }
  }, [_vm._v("\n                        Your own past loss of earnings figure should be greater than £0.00\n                    ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.pastLossOfEarningsPeriods.length), function(index) {
    return (_vm.pastLossOfEarningsType === 'manual') ? _c('div', [_c('earnings-period', {
      attrs: {
        "index": index - 1
      },
      on: {
        "update": function($event) {
          return _vm.updateValid()
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.pastLossOfEarningsPeriods.length >= 0 && _vm.pastLossOfEarningsType === 'manual') ? _c('button', {
    staticClass: "a-button a-button--no-margin",
    staticStyle: {
      "margin-bottom": "40px"
    },
    on: {
      "click": _vm.addLossOfEarningsPeriod
    }
  }, [_vm._v("\n                    Add Period\n                ")]) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "past_loss_of_earnings",
      "label": "Past Loss of Earnings Total",
      "before-after": "pound"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.currencyFormat(_vm.findValue('pastLossOfEarnings'), '')
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "u-margin-top-40 u-r-margin-top-0"
  }, [_c('control', {
    attrs: {
      "label": "Care",
      "tip-text": "You have three options to assess the care claim — click the help icon to find out more.",
      "tip-icon": "info",
      "tip-side": "left",
      "tip-width": "200",
      "tip-name": "care",
      "modalName": "careModal"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.careCalcType),
      expression: "careCalcType"
    }],
    attrs: {
      "id": "careCalcType",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.careCalcType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "own"
    }
  }, [_vm._v("Enter your own figure")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "auto"
    }
  }, [_vm._v("Auto-calculate")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "manual"
    }
  }, [_vm._v("Detailed calculation")])])])], 1), _vm._v(" "), (_vm.careCalcType === 'own') ? _c('control', {
    attrs: {
      "for": "ownCareFigure",
      "label": "Enter Your Own Figure",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ownCareFigure),
      expression: "ownCareFigure",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:ownCareFigure.valid",
      value: ({
        type: 'number',
        rules: 'valid'
      }),
      expression: "{type:'number', rules:'valid'}",
      arg: "ownCareFigure",
      modifiers: {
        "valid": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "ownCareFigure",
      "min": "0.00"
    },
    domProps: {
      "value": (_vm.ownCareFigure)
    },
    on: {
      "focus": function($event) {
        _vm.ownCareFigure = _vm.ownCareFigure || ''
      },
      "blur": [function($event) {
        _vm.ownCareFigure = _vm.ownCareFigure || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ownCareFigure = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('ownCareFigure')
    }
  }, [_vm._v("\n                        Your own care figure should be greater than £0.00\n                    ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.periods.length), function(index) {
    return (_vm.careCalcType === 'manual') ? _c('div', [_c('care-period', {
      attrs: {
        "index": index - 1
      },
      on: {
        "update": function($event) {
          return _vm.updateValid()
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.periods.length >= 0 && _vm.careCalcType === 'manual') ? _c('button', {
    staticClass: "a-button a-button--no-margin",
    staticStyle: {
      "margin-bottom": "40px"
    },
    on: {
      "click": _vm.addCarePeriod
    }
  }, [_vm._v("\n                    Add Period\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'a-loader--care': _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('control', {
    attrs: {
      "for": "care_total",
      "label": "Care Total",
      "before-after": "pound",
      "tip-icon": _vm.careIcon,
      "tip-show": _vm.careCalcType === 'auto',
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "care_total",
      "modal-name": 'headsOfLoss_' + _vm.uniqueId,
      "endpoint": 'autoCare'
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.currencyFormat(_vm.findValue('pastCostOfCare'), '')
    }
  })])], 1) : _vm._e()], 2)])]), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.isValid()
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "pastLossOfEarningsModal",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("\n            Past Loss of Earnings Claim Options\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            You have two options to assess the care claim:"), _c('br')]), _vm._v(" "), _c('ul', {
    staticClass: "u-margin-lr-40"
  }, [_c('li', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                You can simply enter in a £ sum for the known past loss of earnings.\n            ")]), _vm._v(" "), _c('li', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                You can carry out a detailed calculation looking at differing periods and calculating from either Net or Gross income per annum.\n            ")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "careModal",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("\n            Care Claim Options\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            You have three options to assess the care claim:"), _c('br')]), _vm._v(" "), _c('ul', {
    staticClass: "u-margin-lr-40"
  }, [_c('li', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                You can simply enter in a £ sum for the care.\n            ")]), _vm._v(" "), _c('li', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                You can Auto-calculate the award. The CA in Rothwell v Chemical Insulating Co. Ltd [2006] EWCA Civ 27 recognised a sum of £12,500 as the norm for care in claims for terminal malignant mesothelioma. This award is inflated to today’s value applying the Retail Price Index since January 2006.\n            ")]), _vm._v(" "), _c('li', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                You can carry out a detailed calculation looking at differing periods and differing hours of care and applying either a basic or aggregate care rate valued according to Local Authority Spinal Point 8. You can then discount the claim by 25% to reflect the gratuitous rather than commercial nature of the care.\n            ")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'headsOfLoss_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "generalDamagesPslaModal",
      "no-default-button": "true"
    }
  }, [(_vm.modals.generalDamagesPslaModal) ? _c('general-damages-psla-calculator') : _vm._e()], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "lossOfSpouse",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("\n            Loss of Spouse\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Also known as ‘Regan Awards’ and awards for ‘loss of intangible benefits’, this head of loss is usually claimed for the loss of services provided by a spouse/parent which go beyond what can be commercially sourced e.g. care and attention. Originally established in Regan v Williamson, we discussed the most recent case law in "), _c('a', {
    attrs: {
      "href": "https://www.bc-legal.co.uk/images/pdf/177-BC-Disease-News-2017-03-17-Edition-177.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Edition 177 of BC Disease News")]), _vm._v(".\n        ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7a9fb605!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/fatal-accident-claims/estate/steps/HeadsOfLossAndPastLossOfEarnings.vue
// module id = 1755
// module chunks = 0